import React, { Fragment, useContext } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import Typography from "@mui/material/Typography";
import TranscriptSummaryViewModel from "./Transcripts/TranscriptSummaryViewModel";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface ITranscriptSummaryProps {
    summary?: TranscriptSummaryViewModel | null
}

export default function TranscriptSummary(props: ITranscriptSummaryProps) {
    const { showMessage } = useContext(APIContext);

    const displayTranscriptSummary = () => {
        if (props.summary) {
            return props.summary.summary;
        }
        else {
            return "No transcript summary found for this call";
        }
    }

    const copySummaryToClipboard = () => {
        navigator.clipboard.writeText(props.summary!.summary);
        showMessage("success", "Summary copied to clipboard");
    }

    return (
        <Fragment>
            <Grid container justifyContent="space-between" sx={{ pl: 1, pr: 1 }}>
                <Typography variant="h6"><u>{`Transcript Summary`}</u></Typography>
                {
                    props.summary &&
                    <Grid>
                        <Button onClick={() => copySummaryToClipboard()}><ContentCopyIcon /></Button>
                    </Grid>
                }
            </Grid>
            <Typography variant='body2' padding={1}>{displayTranscriptSummary()}</Typography>
        </Fragment>
    )
}